// document.addEventListener("DOMContentLoaded", function () {   
//   const tabLinks = document.querySelectorAll(".tabify-link");
//   const tabPanels = document.querySelectorAll(".tab-panel");
//   const reviewTabLink = document.querySelector("#tab-link-reviews_tab");
//   const reviewTabPanel = reviewTabLink ? document.querySelector(`#${reviewTabLink.getAttribute("aria-controls")}`) : null;
//   const reviewWrap = document.querySelector(".product_review-wrap");

//   function activateTab(link) {
//       // Remove active class from all links and hide all panels
//       tabLinks.forEach((item) => item.classList.remove("active"));
//       tabPanels.forEach((panel) => panel.classList.remove("show"));

//       // Add active class to the clicked link and show corresponding panel
//       link.classList.add("active");
//       const tabPanel = document.querySelector(link.getAttribute("href"));
//       if (tabPanel) {
//           tabPanel.classList.add("show");
//       }
//   }

//   // Attach click event to each tab link
//   tabLinks.forEach((link) => {
//       link.addEventListener("click", function (event) {
//           event.preventDefault();
//           activateTab(this);
//       });
//   });

//   // Activate the first tab by default
//   if (tabLinks.length > 0) {
//       activateTab(tabLinks[0]);
//   }

//   // Click event for the review section to scroll and activate the review tab
//   if (reviewWrap && reviewTabLink) {
//       reviewWrap.addEventListener("click", function () {
//           if (reviewTabLink) {
//               activateTab(reviewTabLink);
//           }
//           document.querySelector(".product-details-tabify").scrollIntoView({ behavior: "smooth" });
//       });
//   }
// });


// document.addEventListener("DOMContentLoaded", function () {
//   let buttons = document.querySelectorAll(".collapsible-btn");

//   buttons.forEach((button) => {
//     button.addEventListener("click", function () {
//       console.log("mk")
//       let content = this.nextElementSibling;
//       let isActive = this.classList.contains("active");

//       // Close all accordions
//       document.querySelectorAll(".collapsible-btn").forEach((btn) => {
//         btn.classList.remove("active");
//         // btn.querySelector(".icon-plus").style.display = "inline-block";
//         // btn.querySelector(".icon-minus").style.display = "none";
//       });
//       document.querySelectorAll(".description_tab_content").forEach((cont) => cont.classList.remove("open"));

//       // Toggle current accordion
//       if (!isActive) {
//         this.classList.add("active");
//         content.classList.add("open");
//         // this.querySelector(".icon-plus").style.display = "none"; // Hide plus icon
//         // this.querySelector(".icon-minus").style.display = "inline-block"; // Show minus icon
//       }
//     });
//   });
// });



document.addEventListener("DOMContentLoaded", function() {
    const tabLinks = document.querySelectorAll('.tabify-link'); 
    tabLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
      });
    });

  const reviewTabLink = document.querySelector("#tab-link-reviews_tab");
  const reviewWrap = document.querySelector(".product_review-wrap");
  const tabItems = document.querySelectorAll('.tab-item-desktop');
  const tabPanels = document.querySelectorAll('.tab-panel');
  const mobileTabs = document.querySelectorAll('.tabs.mobile-tabs');

  function activateTab(index) {
    tabItems.forEach((tab) => tab.classList.remove('active'));
    tabPanels.forEach((panel) => panel.classList.remove('show'));
    tabItems[index].classList.add('active');
    tabPanels[index].classList.add('show');
  }

  function activateMobileTab(index) {
    console.log("index====>",index);
    if (mobileTabs[index].classList.contains('active')) {
      mobileTabs[index].classList.remove('active');
      tabPanels[index].classList.remove('show');
    } else {
      mobileTabs.forEach((mt) => mt.classList.remove('active'));
      tabPanels.forEach((panel) => panel.classList.remove('show'));
      mobileTabs[index].classList.add('active');
      tabPanels[index].classList.add('show');
    }
  }

  tabItems.forEach((tab, index) => {
    tab.addEventListener('click', function() {
      activateTab(index);
    });
  });

  mobileTabs.forEach((mobileTab, index) => {
    mobileTab.addEventListener('click', function() {
      activateMobileTab(index);
    });
  });

  activateTab(0);
  if (mobileTabs.length > 0) {
    activateMobileTab(0);
  }

  if (reviewWrap && reviewTabLink) {
    reviewWrap.addEventListener("click", function () {
        const tabifyLinks = Array.from(document.querySelectorAll(".tabify-link"));
        console.log("tabifyLinks====>",tabifyLinks);
        const reviewIndex = tabifyLinks.indexOf(reviewTabLink);
        console.log("reviewIndex====>",reviewIndex);

        if (reviewIndex !== -1 && tabItems[reviewIndex]) {
            activateTab(reviewIndex);
            activateMobileTab(reviewIndex);
        }
        document.querySelector(".product-details-tabify").scrollIntoView({ behavior: "smooth" });
    });
  }
});







